package game.controller

import com.soywiz.korge.input.Input
import game.Game
import game.ROOM_WIDTH
import game.Room
import view.Terminal

class TeleportTransitionController : GameController() {
    private var firstTick = true
    private var renderPlayer = true
    private var redden = false
    var startCol = 0
    var startRow = 0
    var endCol = 0
    var endRow = 0
    private lateinit var destRoom: Room
    private var coolDown = 0.0
    private var transitionDuration = ROOM_WIDTH.toDouble() * 1.5
    private val ratio: Double
        get() = (transitionDuration - coolDown) / transitionDuration

    override fun onActivate(game: Game) {
    }

    override fun onTick(game: Game, input: Input) {
        if (firstTick) {
            game.playSound("teleport")
            firstTick = false
        }

        coolDown--
    }

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderUi(terminal)
        when {
            ratio < 0.5 -> {
                val radius = ((1.0 - (ratio * 2.0)) * ROOM_WIDTH).toInt()
                game.renderStage(terminal, renderPlayer)
                game.renderCircle(terminal, radius, startCol, startRow)
            }
            ratio < 1.0 -> {
                if (game.currentRoom != destRoom) {
                    game.loadRoom(destRoom.id)
                    game.player.col = endCol
                    game.player.row = endRow
                }
                val radius = (((ratio - 0.5) * 2.0) * ROOM_WIDTH).toInt()
                game.renderStage(terminal, renderPlayer)
                game.renderCircle(terminal, radius, endCol, endRow)
            }
            else -> {
//                godlair.loadRoom(destRoom.id)
                game.controller = nextController
            }
        }
    }

    fun startTeleport(startCol: Int, startRow: Int, endCol: Int, endRow: Int, destRoom: Room, renderPlayer: Boolean = true) {
        this.coolDown = transitionDuration
        this.startCol = startCol
        this.startRow = startRow
        this.endCol = endCol
        this.endRow = endRow
        this.destRoom = destRoom
        this.renderPlayer = renderPlayer
    }
}